<template>
  <section v-if="receiveItems.length">
    <table class="table table-sm table-bordered">
      <thead class="thead-light">
        <tr>
          <th class="w-min no-br">{{ "index" | translate }}</th>
          <th>{{ "from" | translate }}</th>
          <th>{{ "merchandise_vendor" | translate }}</th>
          <th>{{ "merchandise_quantity" | translate }}</th>
          <th>{{ "transactions" | translate }}</th>
          <th>{{ "comment" | translate }}</th>
          <th v-no-print v-if="!readonly">@</th>
        </tr>
      </thead>

      <tbody>
        <tr :key="'item' + index" v-for="(item, index) in receiveItems">
          <td>{{ index + 1 }}</td>
          <td class="w-15">{{ item.from }}</td>
          <td class="w-15">{{ item.merchandiseVendor }}</td>
          <td>{{ item.merchandiseQuantity }}</td>
          <td class="w-30">
            <part-transaction-list-present
              :transactions="item.transactions"
            ></part-transaction-list-present>
          </td>
          <td class="w-15">{{ item.comment }}</td>
          <td class="w-min no-br" v-no-print v-if="!readonly">
            <a
              class="mr-1"
              href="javascript:void(0)"
              @click="editPurchaseOrderItem(item)"
              >{{ "edit" | translate }}</a
            >
            <a href="javascript:void(0)" @click="remove(index)">{{
              "remove" | translate
            }}</a>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <th colspan="3">{{ "total" | translate }}</th>
          <th>{{ totalQuantity }}</th>
          <th class="text-right" colspan="2">
            <div v-for="(total, index) in totalAmounts" :key="'t' + index">
              {{ total.total | number(2) }} {{ total.currency | translate }}
            </div>
          </th>
          <th v-no-print v-if="!readonly"></th>
        </tr>
      </tfoot>
    </table>
  </section>
</template>

<script>
import { ModalService } from "@/modules/xs-modal";
import ModalReceiveItemForm from "./ModalReceiveItemForm";
import PartTransactionListPresent from "./PartTransactionListPresent";
import _ from "lodash";

export default {
  props: ["receiveItems", "readonly"],
  data() {
    return {};
  },
  computed: {
    totalQuantity() {
      return this.receiveItems.reduce((sum, item) => {
        if (item.merchandiseQuantity) {
          return sum + item.merchandiseQuantity;
        }
        return sum;
      }, 0);
    },
    totalAmounts() {
      let currencyList = [
        ...new Set(
          this.receiveItems
            .flatMap(item => item.transactions)
            .map(trans => trans.currency)
            .filter(cur => cur)
        )
      ];

      return currencyList.map(curr => {
        return {
          currency: curr,
          total: this.receiveItems.reduce((sum, item) => {
            return (
              sum +
              item.transactions.reduce((tSum, trn) => {
                if (trn.currency === curr) {
                  return tSum + trn.amount;
                }
                return tSum;
              }, 0)
            );
          }, 0)
        };
      });
    }
  },
  methods: {
    editPurchaseOrderItem(item) {
      ModalService.open(ModalReceiveItemForm, {
        editingItem: item
      }).then(purchaseOrderItem => {
        _.assign(item, purchaseOrderItem);
        this.$emit("update");
      });
    },
    remove(index) {
      this.receiveItems.splice(index, 1);
      this.$emit("update");
    }
  },
  components: {
    PartTransactionListPresent
  }
};
</script>
